module.exports = __webpack_public_path__ + "static/media/PlusOutlined.4786a7eb.svg";